import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { EngineeringTableForm, EngineeringTableFormType } from './EngineeringTableForm'
import { getEngineeringTableRowById, updateEngineeringTableRow } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useParams } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Engineering Table',
    path: '/system/vertical-support-engineering'
  },
  {
    label: 'Edit',
    isCurrentPage: true
  }
]

export const EditEngineeringTableRow = () => {
  const { rowId } = useParams()
  const { createToast } = useAppContext()
  const [row, setRow] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getEngineeringTableRowById(rowId)
        setRow(data)
      } catch (err) {
        createToast('error', 'Error', err.response?.data)
      }
    }
    load()
  }, [])

  const handleEdit = async (form) => {
    setIsSubmitting(true)
    try {
      const updated = await updateEngineeringTableRow(rowId, form)
      if (updated) {
        setRow(updated)
        createToast('success', 'Engineering table row updated.')
      } else {
        createToast('error', 'Failed to update.')
      }
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response?.data?.error || err.response?.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Edit Engineering Table Row</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Row Data</Heading>
          </CardHeader>
          <CardBody p={8}>
            <EngineeringTableForm
              type={EngineeringTableFormType.Edit}
              onSubmit={handleEdit}
              isSubmitting={isSubmitting}
              initialForm={row}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
